/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SunMoonIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="sun-moon"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M14.818 14.796A5.609 5.609 0 1 1 9.209 9.187" data-tinysvg-shape="arc" data-tinysvg-arc="9.209 14.796 5.609 5.609 0 270 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14.818 14.796A3.967 3.967 0 1 1 9.209 9.187" data-tinysvg-shape="arc" data-tinysvg-arc="11.96 12.045 3.967 3.967 43.898 226.102 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12.401 8.196A3.3 3.3 0 0 1 15.701 11.496" data-tinysvg-shape="arc" data-tinysvg-arc="12.401 11.496 3.3 3.3 270 0 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12.401 2.696L12.401 4.896" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.623 5.273L17.067 6.829" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M21.201 11.496L19.001 11.496" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
